<!--
# Module: 重置密码
-->
<template>
  <div class="pwd-main">
    <div class="common-header">
        <div class="header-wrap">
            <div class="header-lf">
                <div class="sys-name inline-block">
                    <img class="logo inline-block" src="../../assets/images/logo.jpg" alt="logo">
                    <span class="name inline-block">顺德区非居民用水累计加价系统</span>
                </div>
                <div class="model-name inline-block">重置密码</div>
            </div>
            <div class="header-rg">
                <router-link to="/skjs/login" class="link">登陆</router-link>
            </div>
        </div>
    </div>
    <div class="section-subnav">
        <div>
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="确认账号"></el-step>
                <el-step title="身份验证"></el-step>
                <el-step title="设置新密码"></el-step>
                <el-step title="完成"></el-step>
            </el-steps>
        </div>
    </div>
    <div class="section-main">
        <div class="main-form">
            <!-- 步骤一：确认账号 -->
            <template v-if="stepActive === 0">
                <div class="in-row">
                    <p class="txt">账号：</p>
                    <div class="in-box"><el-input v-model="account" placeholder="请输入账号" size="small" clearable></el-input></div>
                </div>
            </template>
            <!-- 步骤一：确认账号 -->
            <!-- 步骤二：身份验证 -->
            <template v-else-if="stepActive === 1">
                <div class="in-row">
                    <p class="txt">绑定的手机号码：</p>
                    <div class="in-box"><el-input v-model="phone" placeholder="请输入账号绑定的手机号码" size="small" clearable></el-input></div>
                </div>
                <div class="in-row">
                    <p class="txt">验证码：</p>
                    <div class="verify">
                    <div class="verify-box inline-block"><el-input placeholder="验证码" v-model="verify" clearable size="small"></el-input></div>
                    <div class="verify-btn inline-block" v-if="!phoneVerify" @click="$getPhoneVerify">获取验证码</div>
                    <div class="verify-tips inline-block" v-else>已发送({{countDown}}s)</div>
                    </div>
                </div>
            </template>
            <!-- 步骤二：身份验证 -->
            <!-- 步骤三：设置密码 -->
            <template v-if="stepActive === 2">
                <transition name="el-fade-in"><p class="tips" v-if="valipwdTip"><i class="ico el-icon-warning"></i>密码必须六位以上且包含字母(不区分大小写)、数字或特殊符号</p></transition>
                <div class="in-row">
                    <p class="txt">新密码：</p>
                    <div class="in-box"><el-input v-model="pwd" placeholder="请输入新密码" size="small" clearable show-password></el-input></div>
                </div>
                <div class="in-row">
                    <p class="txt">确认密码：</p>
                    <div class="in-box"><el-input v-model="password" placeholder="再次输入新密码" size="small" clearable show-password></el-input></div>
                </div>
            </template>
            <!-- 步骤三：设置密码 -->
            <!-- 步骤四：完成 -->
            <template v-if="stepActive === 4">
                <div class="suc-tips">
                    <div class="ico"><span class="iconfont">&#xe63c;</span></div>
                    <div class="txt">密码设置成功！</div>
                    <div class="btn"><router-link to="/skjs/login" class="link">去登陆</router-link></div>
                </div>
            </template>
            <!-- 步骤四：完成 -->
            <!-- 下一步 -->
            <div class="in-row" v-if="stepActive < 3">
                <span class="btn-box" @click="handleResetPwdStepsMove">下一步</span>
            </div>
            <!-- 下一步 -->
        </div>
    </div>
    <!-- 页脚：版权信息 -->
    <Copyright></Copyright>
    <!-- 页脚：版权信息 -->
  </div>
</template>

<script>
import Copyright from '@/views/public/Copyright'
import { validatePassword } from '@/assets/js/validate'
import {
  A_UA_SendVerify,
  A_UA_ValidateVerify,
  A_UA_ValidatePhone,
  A_UA_AuthUpdate,
  A_UA_UpdatePwd
} from '@/assets/js/axiosPresets'
export default {
  name: 'topHeader',
  data () {
    return {
      stepActive: 0, // 步骤active
      btnLoad: false, // 下一步按钮loading
      account: '', // 账号
      phone: '', // 手机号码
      verifyBol: false, // 首次是否请求过验证码
      verify: '', // 验证码
      phoneVerify: false, // 是否已获取手机验证码
      countDown: 60, // 获取验证码倒计时
      pwd: '', // 新密码
      password: '', // 确认新密码
      valipwdTip: false // 密码规则提示
    }
  },
  components: {
    Copyright
  },
  mounted () {

  },
  methods: {
    // 功能：重置密码走流程
    async handleResetPwdStepsMove () {
      if (this.btnLoad) {
        this.$message({ type: 'info', message: '请勿频繁操作' })
        return false
      }
      this.btnLoad = true
      switch (this.stepActive) {
        case 0: // 步骤一：确认账号
          if (!this.account) {
            this.$message({ type: 'error', message: '请先填写账号' })
            this.btnLoad = false
            return false
          }
          break
        case 1: // 步骤二：身份验证
          if (!this.phone) {
            this.$message({ type: 'error', message: '请填写账号绑定的手机号码' })
            this.btnLoad = false
            return false
          } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
            this.$message({ type: 'error', message: '填写的手机号码不合法' })
            this.btnLoad = false
            return false
          }
          if (!this.verify) {
            this.$message({ type: 'error', message: '请先填写验证码' })
            this.btnLoad = false
            return false
          }
          // 绑定是否未获取过验证码
          if (!this.verifyBol) {
            this.$message({ type: 'error', message: '请先获取验证码' })
            this.btnLoad = false
            return false
          }
          // 校验手机号是否为该账号所绑定的手机号
          var Vphone = await this.$validatePhone()
          if (!Vphone) {
            this.$message({ type: 'error', message: '请填写账号绑定的手机号码' })
            this.btnLoad = false
            return false
          }
          // 校验手机验证码
          var VerR = await this.$validateVerify()
          if (!VerR) {
            this.btnLoad = false
            return false
          }
          break
        case 2: // 步骤三：设置新密码
          if (!this.pwd) {
            this.$message({ type: 'error', message: '请输入新密码' })
            this.btnLoad = false
            return false
          }
          if (!this.password) {
            this.$message({ type: 'error', message: '请再次输入新密码' })
            this.btnLoad = false
            return false
          }
          if (this.pwd !== this.password) {
            this.$message({ type: 'error', message: '两次输入的密码不一致' })
            this.btnLoad = false
            return false
          }
          // 检验密码
          var valipwd = validatePassword(this.password)
          if (!valipwd) {
            this.valipwdTip = true
            this.btnLoad = false
            this.$message({ type: 'error', message: '密码格式不正确' })
            return false
          }
          // 提交
          var AuR = await this.$authUpdate()
          if (!AuR) {
            this.$message({ type: 'error', message: '设置失败' })
            this.btnLoad = false
            return false
          }
          break
      }

      this.stepActive++
      this.btnLoad = false
      // 已完成
      if (this.stepActive === 3) {
        this.stepActive++
      }
    },
    // 数据：获取手机验证码
    async $getPhoneVerify () {
      if (!this.phone) {
        this.$message({ type: 'error', message: '请填写账号绑定的手机号码' })
        return false
      } else {
        if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
          this.$message({ type: 'error', message: '填写的手机号码不合法，请重新填写' })
          return false
        }
        // 校验手机号是否为该账号所绑定的手机号
        var Vphone = await this.$validatePhone()
        if (!Vphone) {
          this.$message({ type: 'error', message: '请填写账号绑定的手机号码' })
          return false
        }
      }

      // state： 1手机 2密码
      var R = await this.$F_checkAxios(A_UA_SendVerify({
        Mobiles: this.phone,
        state: 2
      }))
      if (!R) {
        return
      }
      this.verifyBol = true
      this.phoneVerify = true
      this.handleCountDown()
    },
    // 数据：检验手机验证码
    async $validateVerify () {
      var Result = false
      var R = await A_UA_ValidateVerify({
        Code: this.verify
      })
      var RData = JSON.parse(R.data.d)
      if (RData.returnCode === 1) {
        Result = true
      } else {
        if (RData.resultMaps) {
          this.$message({ type: 'error', message: `${RData.resultMaps}` })
        }
      }

      return Result
    },
    // 数据：检验手机验证码
    async $validatePhone () {
      var Result = false
      var R = await A_UA_ValidatePhone({
        username: this.account
      })
      var RData = JSON.parse(R.data.d)
      if (RData.returnCode === 1) {
        var data = JSON.parse(RData.resultMaps)
        if (data.length > 0) {
          var obj = data[0]
          // eslint-disable-next-line no-unneeded-ternary
          Result = obj.mobile === this.phone ? true : false
        }
      } else {
        if (RData.resultMaps) {
          this.$message({ type: 'error', message: `${RData.resultMaps}` })
        }
      }

      return Result
    },
    // 数据：提交
    async $authUpdate () {
      var Result = false
      var R = await A_UA_UpdatePwd({
        model: {
          user_name: this.account,
          password: this.password
        }
      })
      var RData = JSON.parse(R.data.d)
      if (RData.returnCode === 1) {
        Result = true
      } else {
        if (RData.resultMaps) {
          this.$message({ type: 'error', message: `${RData.resultMaps}` })
        }
      }

      return Result
    },
    // 功能：倒计时
    handleCountDown () {
      if (this.countDown === 1) {
        this.phoneVerify = false
        this.countDown = 60
        return false
      }
      this.countDown--
      setTimeout(() => {
        this.handleCountDown()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.pwd-main {
    position: relative;
    height: 100%;

    .inline-block {
        display: inline-block;
        vertical-align: middle;
    }

    .common-header {
        width: 100%;
        height: 60px;
        background: #06367D;
        // background: linear-gradient(-125deg,#01042B 0%, #325EA1 100%);

        .header-wrap {
            padding: 10px 0;
            margin: 0 auto;
            width: 1200px;
            height: calc(100% - 20px);

            .header-lf {
                height: 100%;
                float: left;
                margin-left: 75px;

                .sys-name {
                    height: 100%;

                    .logo {
                        width: 33px;
                    }

                    .name {
                        margin-left: 10px;
                        font-size: 18px;
                        font-weight: 700;
                        color: #fff;
                    }
                }

                .model-name {
                    margin-left: 15px;
                    padding-left: 15px;
                    border-left: 1px solid #7384a7;
                    color: #fff;
                    line-height: 16px;
                    font-size: 14px;
                }
            }

            .header-rg {
                height: 100%;
                position: relative;
                float: right;
                line-height: 40px;

                .link {
                    position: relative;
                    color: #fff;

                    &:hover {
                        &::after {
                            left: 0;
                            right: 0;
                        }
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -3px;
                        left: 50%;
                        right: 50%;
                        height: 2px;
                        background: linear-gradient(125deg, #18cef2 0%, #448aff 100%);
                        transition: all .3s;
                    }
                }
            }
        }
    }

    .section-subnav {
        background-color: #f5f5f5;

        > div {
            padding: 15px 0 8px;
            margin: 0 auto;
            width: 1000px;
            height: 100%;
        }
    }

    .section-main {
        height: calc(100% - 80px - 60px);
        background-color: #fff;

        .main-form {
            margin: 0 auto;
            padding-top: 70px;
            width: 290px;

            .tips {
                margin-bottom: 15px;
                color: #9a0b2c;

                .ico {
                    margin-right: 5px;
                }
            }

            .in-row {
                margin-bottom: 20px;

                .txt {
                    margin-bottom: 8px;
                    font-size: 14px;
                }

                .btn-box {
                    display: inline-block;
                    margin-top: 20px;
                    padding: 7px 20px;
                    min-width: 60px;
                    text-align: center;
                    background: #2f86f6;
                    font-size: 16px;
                    color: #fff;
                    box-shadow: 0 3px 0 #266ecb;
                    border-radius: 2px;
                    cursor: pointer;

                    &:hover {
                        background-color: #4692f4;
                    }
                }

                .verify {
                    .verify-box {
                        margin-right: 15px;
                        width: 140px;
                    }

                    .verify-btn {
                        cursor: pointer;
                        color: #129ac6;
                    }

                    .verify-tips {
                        background-color: #e5e5e5;
                        padding: 5px 10px;
                        border: 1px solid #ddd;
                        font-size: 12px;
                        border-radius: 2px;
                    }
                }
            }

            .suc-tips {
                margin-top: 90px;
                text-align: center;

                .ico {
                    > span {
                        display: inline-block;
                        font-size: 60px;
                        color: #67C23A;
                    }
                }

                .txt {
                    font-size: 18px;
                }

                .btn {
                    margin-top: 50px;

                    .link {
                        display: inline-block;
                        padding: 7px 20px;
                        min-width: 60px;
                        text-align: center;
                        background: #2f86f6;
                        font-size: 16px;
                        color: #fff;
                        box-shadow: 0 3px 0 #266ecb;
                        border-radius: 2px;
                        cursor: pointer;

                        &:hover {
                            background-color: #4692f4;
                        }
                    }
                }
            }
        }
    }
}
</style>